import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

export const i18nLanguageKey = 'i18nLang';

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        ns: ['common'],
        debug: true,
        fallbackLng: 'en',
        load: 'languageOnly',
        backend: {
            loadPath: `/locales/{{lng}}/{{ns}}.json?v=${process.env.REACT_APP_BUILD_VERSION}`
        },
        interpolation: {
            escapeValue: false, // React escapes all string by default
        },
        detection: {
            order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator'],
            caches: [],
            lookupLocalStorage: i18nLanguageKey
        }
    });

export default i18n;